import { registerQuery, registerMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const RESUME_LIST = registerQuery({
  fieldName: 'ilsResumeList',
  args: ['listId'],
  fetcher: ({
    listId
  }) => {
    return http.put(`inbounddb-lists/v1/lists/resume/${listId}`);
  }
});
export const GET_ILS_LIST_METADATA = registerQuery({
  fieldName: 'ilsListMetadata',
  args: ['listId'],
  fetcher: ({
    listId
  }) => {
    return http.get(`inbounddb-lists/v1/lists/${listId}`, {
      query: {
        includePrivate: true
      }
    });
  }
});
export const GET_ILS_LIST_SIZE = registerQuery({
  fieldName: 'ilsListSize',
  args: ['listId'],
  fetcher: ({
    listId
  }) => {
    return http.get('inbounddb-lists-membership/v1/list-memberships/size', {
      query: {
        listId
      }
    });
  }
});

// not supported for larger number of lists, use SEARCH_ILS_LIST_BY_TYPE instead
export const GET_ILS_LIST_BY_TYPE = registerQuery({
  fieldName: 'ilsListByType',
  args: ['objectTypeId'],
  fetcher: ({
    objectTypeId
  }) => {
    return http.get(`inbounddb-lists/v1/lists/type/${objectTypeId}`);
  }
});
export const SEARCH_ILS_LIST_BY_TYPE = registerQuery({
  fieldName: 'searchIlsListByType',
  args: ['objectTypeId', 'query'],
  fetcher: ({
    objectTypeId,
    query
  }) => {
    return http.post(`inbounddb-lists/v1/segments-ui/searchLists`, {
      data: {
        // random number to basically fetch all lists
        // choosing not to implement pagination until we get negative feedback
        count: 500,
        offset: 0,
        fetchAllProperties: false,
        fetchAllCustomProperties: false,
        properties: ['hs_list_name', 'hs_list_id', 'hs_object_type_id'],
        query,
        listFilterProperties: {
          objectTypeId,
          processingTypes: ['DYNAMIC', 'SNAPSHOT', 'MANUAL']
        },
        includePrivate: false
      }
    });
  }
});
export const GET_ILS_LIST_BY_ID = registerQuery({
  fieldName: 'ilsListById',
  args: ['listId'],
  fetcher: ({
    listId
  }) => {
    return http.get(`inbounddb-lists/v1/lists/${listId}`);
  }
});
export const GET_ILS_OBJECT_IDS_BY_LIST = registerQuery({
  fieldName: 'objectIdsByList',
  args: ['listId'],
  fetcher: ({
    listId
  }) => {
    return http.get(`automationplatform/v1/list-proxy/membership`, {
      query: {
        listId
      }
    });
  }
});
export const SAVE_NEW_ILS_LIST = registerMutation({
  fieldName: 'saveNewILSList',
  args: ['name', 'objectTypeId'],
  fetcher: ({
    name,
    filterBranch,
    objectTypeId
  }) => {
    return http.post('inbounddb-lists/v1/lists', {
      query: {
        referenceTypeSafe: 'USER_PORTAL',
        referenceId: '',
        public: true
      },
      data: {
        processingType: 'SNAPSHOT',
        name,
        objectTypeId,
        filterBranch
      }
    });
  }
});
export const BULK_DELETE_BY_LIST_IDS = registerMutation({
  fieldName: 'numberOfListsDeleted',
  args: ['listIds'],
  fetcher: ({
    listIds
  }) => {
    const listIdsFormatted = listIds.map(listId => {
      return {
        ilsListId: listId
      };
    });
    return http.post('inbounddb-lists/v1/lists/bulkDeleteLists', {
      data: listIdsFormatted
    });
  }
});